import { DEFAULT_FONTS } from '../../constants/fonts';
import globalConstants from '../global/global-constants';
const overrideTypography = (typography, components) => {
    try {
        const overriddenComponents = {};
        for (const [componentName, componentProperties] of Object.entries(components)) {
            const typographyElem = typography?.components[componentName];
            let overriddenProperties = { ...componentProperties };
            const styleKeys = Object.keys(overriddenProperties);
            const hasMediaQuery = styleKeys.some(item => item.includes('@media'));
            if (typographyElem) {
                styleKeys.forEach(styleKey => {
                    const property = overriddenProperties[styleKey];
                    if (property &&
                        typeof property === 'object' &&
                        'fontSize' in property) {
                        overriddenProperties[styleKey] = {
                            ...property,
                            fontSize: hasMediaQuery
                                ? typographyElem.fontSizes?.mobile
                                : typographyElem.fontSizes?.desktop,
                        };
                    }
                });
                if (!hasMediaQuery) {
                    overriddenProperties = {
                        ...overriddenProperties,
                        [`@media (max-width:${globalConstants.screens.sm}px)`]: {
                            fontSize: typographyElem.fontSizes?.mobile,
                        },
                    };
                }
            }
            let componentOverride = typographyElem
                ? {
                    fontFamily: `"${typographyElem.fontFamily?.name}", ${DEFAULT_FONTS}`,
                    fontSize: typographyElem.fontSizes?.desktop,
                }
                : {};
            if (typographyElem?.fontWeight) {
                componentOverride = {
                    ...componentOverride,
                    fontWeight: typographyElem.fontWeight,
                };
            }
            overriddenComponents[componentName] = {
                ...overriddenProperties,
                ...componentOverride,
            };
        }
        return overriddenComponents;
    }
    catch (e) {
        console.error('Unable to apply custom typography on theme components');
    }
    return components;
};
export default overrideTypography;
//# sourceMappingURL=overrideTypography.js.map